/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import "@fontsource/rubik/hebrew-300.css"
import "@fontsource/rubik/hebrew-400.css"
import "@fontsource/rubik/hebrew-500.css"
import "@fontsource/rubik/hebrew-600.css"
import "@fontsource/rubik/hebrew-700.css"

export const onRouteUpdate = () => {
  if (typeof window !== `undefined`) {
    window.dispatchEvent(new Event(`gatsby:routeUpdate`))
  }
}
